import httpManager from "@/app/shared/utils/httpManager";

export async function fetchDashboardByPortfolio(portfolioId) {
  return await httpManager.get(`/portfolios/${portfolioId}/dashboard/`);
}
